<template>
  <div>
    <ValidationObserver ref="regionForm" tag="form">
      <label class="font-weight-bold">Seleccione Región(es):</label>
      <div class="row">
        <div class="col-12 col-md-4 border-right">
          <div>
            <span class="data-title d-block mb-2">
              Región(es):
            </span>
            <validation-provider v-slot="{ errors }" name="region" rules="required">
              <custom-drop-down
                v-model="currentRegion"
                id="region"
                fieldkey="id"
                fieldname="name"
                placeholder="Seleccione"
                custom-error-msg="El municipio es requerido."
                :error="errors[0]"
                :options="regionsAvailable"
              />
            </validation-provider>
          </div>
          <div class="mt-3">
            <span class="data-title d-block mb-2">
              Lugar:
            </span>
            <validation-provider v-slot="{ errors }" name="location" rules="required">
              <custom-input
                v-model="currentLocation"
                id="location"
                maxlength="256"
                custom-error-msg="El lugar es requerido."
                :error="errors[0]"
              />
            </validation-provider>
          </div>
          <action-button
            id="btn-add"
            type="button"
            text="Añadir"
            i="fas fa-file-plus"
            variant="success"
            class="ml-2 px-4 mb-3 mt-3 float-right actionButton"
            @click="addRegion"
          />
        </div>
        <div class="col-12 col-md-8">
          <span class="data-title d-block mb-2">
            Lugar(es) Seleccionado(s):
          </span>
          <div
            class="specialist-item py-1 px-4 mb-2 mr-2 d-inline-block"
            v-for="(item, index) in value" v-bind:key="index"
          >
            <div class="d-flex">
              <div class="mr-3">
                <span class="font-weight-bold d-block text-nowrap">
                  {{ item.name }}
                </span>
                <small class="text-muted">
                  {{ item.location }}
                </small>
              </div>
              <div class="align-self-center text-center">
                <i
                  id="removed-icon"
                  class="far fa-times-circle text-red cursor-pointer"
                  @click="removeRegion(item)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import CustomDropDown from "custom-drop-down";
import ActionButton from "ActionButton";
import CustomInput from "CustomInput";
import CustomChipsGroup from "CustomChipsGroup";
export default {
  name: "RegionsSection",
  components: {
    CustomDropDown,
    ActionButton,
    CustomInput,
    CustomChipsGroup
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      currentRegion: null,
      currentLocation: null
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    regionsAvailable: {
      get() {
        return this.options.filter(
          e => !this.value.find(x => e.id === x.id) 
        );
      }
    }
  },
  methods: {
    async addRegion() {
      const isValid = await this.$refs.regionForm.validate();
      if (!isValid) {
        return;
      }
      if (this.currentRegion) {
        this.$emit('onRegionSelected', {
          location: this.currentLocation,
          ...this.currentRegion
        });
        this.currentRegion = null;
        this.currentLocation = null;
        await this.$refs.regionForm.reset();
      }
    },
    removeRegion({ id }) {
      this.$emit('onRegionRemove', id);
    },
  },
};
</script>

<style lang="scss" scoped>
.specialist-item {
  border-radius: 50px;
  border: 1px solid rgb(220, 220, 220);
  width: fit-content;
  font-size: 90%;
}
.align-self-center {
  align-self: center !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
